<template>
  <!-- ==== CONTAINER POPUP MAIS EMOLUMENTOS === -->
  <div class="popup" :style="{ top: popupVisible ? '0' : '-100%' }">
    <div class="popup-content">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-data-table
          :headers="headerz"
          :items="emolumentosExtraList"
          :search="searchInDb"
          sort-by="data_"
          class="tabela-pagamento"
          :hide-default-footer="true"
        >
          <template v-slot:item.mes="{ item }">
            <span>{{ utilitarios.getMonthDescription(item.fkMes) }}</span>
          </template>
          <template v-slot:item.emolumento="{ item }">
            <span
              class="color-table-data"
              v-if="item.emolumento === 'Propina'"
              >{{ item.emolumento }}</span
            >
            <v-combobox
              v-else
              v-model="
                emolumentosExtraList[emolumentosExtraList.indexOf(item)]
                  .emolumento
              "
              :items="emolumentosFiltered"
              hide-selected
              filled
              item-text="produto"
              item-value="produto"
              small-chips
              :rules="ruleRequired"
              style="height: 60px"
              @change="selecionaEmolumentoExtra(emolumentosExtraList.indexOf(item))"
            >
            </v-combobox>
          </template>
          <template v-slot:item.rota="{ item }">
            <span v-if="!precisaDasRotas"> N/A </span>
            <v-combobox
              v-if="precisaDasRotas"
              v-model="rotaSelected"
              :items="rotasAll"
              hide-selected
              filled
              style="height: 60px"
              item-text="descricao"
              item-value="id"
              small-chips
              class="redBorder"
            >
            </v-combobox>
          </template>
          <template v-slot:item.disciplina="{ item }">
            <span v-if="!precisaDasDisciplinas"> N/A </span>
            <v-combobox
              v-if="precisaDasDisciplinas"
              v-model="disciplinaSelected"
              :items="disciplinasEstudanteAll"
              hide-selected
              filled
              style="height: 60px"
              item-text="descricao"
              item-value="iddisciplina"
              small-chips
              class="redBorder"
            >
            </v-combobox>
          </template>
          <template v-slot:item.preco="{ item }">
            <span>{{
              utilitarios.IntegerToMoneyValueFatura(
                isNaN(item.preco) ? "" : item.preco
              )
            }}</span>
          </template>
          <template v-slot:item.stock="{ item }">
            <span>{{ item.stock === "" ? "N/A" : item.stock }}</span>
          </template>
          <template v-slot:item.valorMulta="{ item }">
            <span>{{
              utilitarios.IntegerToMoneyValueFatura(
                isNaN(item.valorMulta) ? "" : item.valorMulta
              )
            }}</span>
          </template>
          <template v-slot:item.subtotal="{ item }">
            <v-text-field
              :readonly="
                !emolumentosExtraList[emolumentosExtraList.indexOf(item)]
                  .emolumento ||
                emolumentosExtraList[emolumentosExtraList.indexOf(item)]
                  .emolumento.produto !== 'Propina M'
              "
              background-color="#fff"
              v-model="
                emolumentosExtraList[emolumentosExtraList.indexOf(item)]
                  .subtotal
              "
            ></v-text-field>
          </template>
          <template v-slot:item.semestre="{ item }">
            <span v-if="!precisaDosSemestres"> N/A </span>
            <v-combobox
              v-if="precisaDosSemestres"
              v-model="semestreCadeira"
              :items="opcoesSemestres"
              hide-selected
              filled
              item-text="descricao"
              item-value="id"
              small-chips
              style="height: 60px"
              class="redBorder"
            >
            </v-combobox>
          </template>
          <template v-slot:item.qtd="{ item }">
            <v-text-field
              :rules="ruleNumberNObrigatorioStartWithOne"
              @keyup="calcularSubTotal(item)"
              background-color="#fff"
              v-model="
                emolumentosExtraList[emolumentosExtraList.indexOf(item)].qtd
              "
            ></v-text-field>
          </template>
        </v-data-table>

        <v-card-actions style="background-color: #fff">
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :disabled="!valid"
            @click="finalizarPagamentoExtra()"
          >
            Adicionar
          </v-btn>
          <v-btn color="black darken-1" text @click="fecharCard()">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-form>
      <novo-emolumento></novo-emolumento>
    </div>
  </div>
  <!-- ==== FIM CONTAINER POPUP MAIS EMOLUMENTOS === -->
</template>

<script>
import utilitarios from "../../../plugins/utilitarios";
import NovoEmolumento from './NovoEmolumento.vue'
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  components:{NovoEmolumento},
  data() {
    return {
      valid: true,
      validMulta: true,
      tabelaCamposColor: [],
      validoConfirmacao: true,
      ruleRequired: [(value) => !!value || "campo obrigatorio"],
      ruleNumberNObrigatorioStartWithOne: [
        (value) => {
          const pattern = /^[0-9]+([,.][0-9]+)?$/g;
          return pattern.test(value) || "O valor deve ser numerico.";
        },
      ],
      headerz: [
        { text: "", value: "indice" },
        { text: "Emolumento", value: "emolumento" },
        { text: "Rota", value: "rota" },
        { text: "Disciplina", value: "disciplina" },
        {
          text: "Mês referente",
          align: "start",
          sortable: false,
          value: "mes",
        },
        { text: "Quantidade", value: "qtd" },
        { text: "Preço Unitário", value: "preco" },
        { text: "Multa", value: "valorMulta" },
        { text: "Desconto", value: "desconto" },
        { text: "Semestre", value: "semestre" },
        { text: "subtotal", value: "subtotal" },
      ],
      emolumentosExtraList: [],
      emolumentosFiltered: [],
      emolumentos: [],
      searchInDb: "",
      precisaDosSemestres: false,
      precisaDasRotas: false,
      precisaDasDisciplinas: false,
      semestreCadeira: null,
      rotaSelected: null,
      disciplinaSelected: null,
      rotasAll: [],
      disciplinasEstudanteAll: [],
      opcoesSemestres: [
        { id: 0, descricao: "Todos" },
        { id: 1, descricao: "1º trimestre" },
        { id: 2, descricao: "2º trimestre" },
        { id: 3, descricao: "3º trimestre" }
      ],
      utilitarios: utilitarios,
    };
  },

  props: {
    popupVisible: Boolean,
    estudante: Object,
  },

  created() {
    this.ListarEmolumentos();
    this.emolumentosExtraList.push({
      isSelected: false,
      desconto: 0,
      multa: 0,
      valorMulta: "N/A",
      subtotal: 1,
    });
  },

  methods: {
    async ListarEmolumentos() {
      try {
        this.emolumentos = await axios
          .get("/produtosFindall-empresa")
          .then((res) => res.data);
          this.emolumentosFiltered = this.emolumentos 
          this.emolumentosFiltered.push({produto:'Novo Produto',idEmolumento:-1,})
      } catch (error) {
        Swal.fire("Informação","Ocorreu um erro ao carregar os Produtos","error");
      }
    },

    async carregarRotasTransporte() {
      try {
        this.rotasAll = await axios
          .get("/carregarRotasTransportes")
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante o carregamento das rotas dos transporte!",
          "error"
        );
      }
    },

    fecharCard() {
      this.emolumentosExtraList = [];
      this.$emit("fecharCard", false);
    },

    selecionaEmolumentoExtra(indice) {

      let emolumento = this.emolumentosExtraList[indice].emolumento;

      if(emolumento.idEmolumento === -1){
        this.$store.dispatch('toggleNovoEmolumento', true); // abrir
      }
      
 
      this.precisaDasRotas = false;
      this.precisaDasDisciplinas = false;
      this.precisaDosSemestres = false;

      switch (emolumento.idEmolumento) {
        case 42:
        case 18:
          this.precisaDosSemestres = true;
          break;
        case 3:
          this.precisaDasRotas = true;
          break;
        case 16:
          this.precisaDasDisciplinas = true;
          break;
      }
      this.valid = true;
      this.validMulta = true;
      this.emolumentosExtraList[indice].isSelected = true;
      this.emolumentosExtraList[indice].mes = "N/A";
      this.emolumentosExtraList[indice].multa = "N/A";
      this.emolumentosExtraList[indice].multaValor = "N/A";
      this.emolumentosExtraList[indice].valorMulta = 0;
      this.emolumentosExtraList[indice].qtd = 1;
      this.tabelaCamposColor[indice] = "#ffff99";
      this.validoConfirmacao = true;
  
    },

    calcularSubTotal(item) {
      let qtd_ =
        this.emolumentosExtraList[this.emolumentosExtraList.indexOf(item)].qtd;
      let qtd =
        parseInt(qtd_ === "" ? 1 : qtd_) === 0
          ? 1
          : parseInt(qtd_ === "" ? 1 : qtd_);
      let precoUnitario =
        this.emolumentosExtraList[this.emolumentosExtraList.indexOf(item)]
          .preco;
      let subtotal = precoUnitario * qtd;
      this.emolumentosExtraList[0].subtotal = subtotal;
    },

    async finalizarPagamentoExtra() {
      if (this.$refs.form.validate()) {
        if (this.emolumentosExtraList.length) {
          let isPropinaCadeira;
          let isPropinaE;
          let isTransporte;
          let isExameEspecial;
          this.emolumentosExtraList[0].emolumento.idEmolumento == 42
            ? (isPropinaCadeira = true)
            : (isPropinaCadeira = false);
          this.emolumentosExtraList[0].emolumento.idEmolumento == 18
            ? (isPropinaE = true)
            : (isPropinaE = false);
          this.emolumentosExtraList[0].emolumento.idEmolumento == 3
            ? (isTransporte = true)
            : (isPropinaE = false);
          this.emolumentosExtraList[0].emolumento.idEmolumento == 16
            ? (isExameEspecial = true)
            : (isExameEspecial = false);
          if ((isPropinaCadeira || isPropinaE) && !this.semestreCadeira) {
            Swal.fire(
              "Informação",
              "Por favor! Selecionar o semestre",
              "warning"
            );
          } else if (isTransporte && !this.rotaSelected) {
            Swal.fire(
              "Informação",
              "Por favor! Selecionar a rota do transporte!",
              "warning"
            );
          } else if (isExameEspecial && !this.disciplinaSelected) {
            Swal.fire(
              "Informação",
              "Por favor! Selecionar a disciplina!",
              "warning"
            );
          } else {
            let params = {
              cliente: this.estudante,
              venda: this.emolumentosExtraList,
            };

            if (isPropinaCadeira) {
              this.registroMensalidadeCadeirante(params);
            } else if (isPropinaE) {
              this.registroMensalidadePropinaE(params);
            } else if (isTransporte) {
              this.registroTransporteEstudante(params);
            } else {
              if (isExameEspecial) {
                let emolumento = params.venda[0].emolumento.emolumento;
                let disciplina = this.disciplinaSelected.descricao;
                let novaDescricao = emolumento + " (" + disciplina + ")";
                params.venda[0].emolumento.produto2 = novaDescricao;
              }

              try {
                this.isLoading = true;
                let result = await axios.post("/finalizarPagamentoExtra-Esc", params).then((res) => res.data);

                if (result.affectedRows <= 0) {
                  Swal.fire(
                    "Informação",
                    "<p>Ocorreu um erro ao adicionar os emolumentos, por favor tente novamente</p>",
                    "error"
                  );
                }
              } catch (error) {
                if (error.toString().includes("409")) {
                  Swal.fire(
                    "Informação",
                    "Matrícula e/ou confirmação de matrícula já adicionado(a).",
                    "warning"
                  );
                } else
                  Swal.fire(
                    "Informação",
                    "<p>Ocorreu um erro durante durante o pagamento</p>",
                    "error"
                  );
              } finally {
                this.fecharCard();
              }
            }
          }
        } else {
          Swal.fire(
            "Informação",
            "<p>Emolumentos não selecionado.</p>",
            "info"
          );
        }
      }
    },

    async registroMensalidadeCadeirante(dadosEstudante) {
      let params = {
        matricula: dadosEstudante.cliente.numero_matricula,
        idCurso: dadosEstudante.cliente.idCurso,
        anoacademico: dadosEstudante.cliente.anoacademico,
        semestre_id: this.semestreCadeira.id,
        numeroDeCadeiras: parseInt(dadosEstudante.venda[0].qtd),
        idEmolumento: dadosEstudante.venda[0].emolumento.idEmolumento,
      };

      try {
        let result = await axios
          .post("/criarRegistroMensalidadeCadeirante", params)
          .then((res) => res.data);
        if (result.affectedRows <= 0) {
          Swal.fire(
            "Informação",
            "Erro ao criar registro das mensalidades do cadeirante",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Erro ao criar registro das mensalidades do cadeirante",
          "error"
        );
      } finally {
        this.fecharCard();
        // this.PesquisaLocal(this.estudantePesquisa);
      }
    },

    async registroMensalidadePropinaE(dadosEstudante) {
      let params = {
        matricula: dadosEstudante.cliente.numero_matricula,
        idCurso: dadosEstudante.cliente.idCurso,
        anoacademico: dadosEstudante.cliente.anoacademico,
        semestre_id: this.semestreCadeira.id,
        idEmolumento: dadosEstudante.venda[0].emolumento.idEmolumento,
      };

      try {
        let result = await axios
          .post("/criarRegistroMensalidadePropinaE", params)
          .then((res) => res.data);
        if (result.affectedRows <= 0) {
          Swal.fire(
            "Informação",
            "Erro ao criar registro das mensalidades da propina de estagio",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Erro ao criar registro das mensalidades da propina de estagio",
          "error"
        );
      } finally {
        this.fecharCard();
        // this.PesquisaLocal(this.estudantePesquisa);
      }
    },

    async registroTransporteEstudante(dadosEstudante) {
      let params = {
        matricula: dadosEstudante.cliente.numero_matricula,
        idCurso: dadosEstudante.cliente.idCurso,
        anoacademico: dadosEstudante.cliente.anoacademico,
        idEmolumento: dadosEstudante.venda[0].emolumento.idEmolumento,
        preco: this.rotaSelected.preco,
      };

      try {
        this.isLoading = true;
        let result = await axios
          .post("/criarRegistroTransporteEst", params)
          .then((res) => res.data);
        if (result.affectedRows <= 0) {
          Swal.fire(
            "Informação",
            "Erro ao criar registro das mensalidades dos transportes",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Erro ao criar registro das mensalidades dos transportes",
          "error"
        );
      } finally {
        this.fecharCard();
      }
    },

    async getDisciplinasEstudante() {
      let params = {
        curso: this.estudante.idCurso,
        classe: this.estudante.anoacademico,
      };
      try {
        this.disciplinasEstudanteAll = await axios
          .get(`/getDisciplinasEstudante/${params.curso}/${params.classe}`)
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorreu um ao carregar as disciplinas do estudante!",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: top 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  width: 60%;
  margin-left: 200px;
}

.tabela-pagamento thead {
  background-color: #006699;
}

.tabela-pagamento th {
  color: #fff !important;
}
</style>
